module.exports = __webpack_public_path__ + "media/images/area-badges/eat-better-be8158ca3a2d4722c3046f30bb5866fd.svg";